import React, { useState, useEffect, useMemo } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import { useLazyGetNCRLogListQuery, useLazyGetNCRLogListAgeingAnalysisQuery } from "store/slices/apis/ncrLogApiSlice";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import { RxCross2 } from "react-icons/rx";


const NcrTrackerListPopUp = (props) => {
    const { open, data, handleClose, columns } = props;
    const { projectId } = useParams();
    const [loading, setLoading] = useState(false);
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const dispatch = useDispatch();

    const safeData = {
        Ageing: typeof data?.Ageing === "string" ? data.Ageing : "",
        Assets: typeof data?.Assets === "string" ? data.Assets : "",
        Group: typeof data?.Group === "string" ? data.Group : "",
        Status: typeof data?.Status === "string" ? data.Status : "",
    };

    const isAgeing = !!safeData.Ageing;

    const filters = useMemo(() => {
        let baseFilters = {
            SortBy: sortBy,
            SortOrder: sortOrder,
            Page: pageNumber,
            PageSize: pageSize,
            ProjectId: projectId,
        };

        if (isAgeing) {
            return {
                ...baseFilters,
                bucket: safeData.Ageing || "",
            };
        } else {
            return {
                ...baseFilters,
                NCRorSO: safeData.Group || "",
                Asset: safeData.Assets || "",
                NCRStatus: safeData.Status || "",
            };
        }
    }, [sortBy, sortOrder, pageNumber, pageSize, projectId, safeData, isAgeing]);

    const [triggerNCR, { data: ncrList, isFetching }] = useLazyGetNCRLogListQuery();

    const [triggerAgeing, { data: ageingList, isFetching: ageingLoading }] = useLazyGetNCRLogListAgeingAnalysisQuery();


    useEffect(() => {
        if (!open) return;

        if (isAgeing) {
            triggerAgeing({
                projectId,
                ...filters,
            });
        } else {
            triggerNCR(filters);
        }
    }, [open, isAgeing, projectId, pageNumber, pageSize, sortBy, sortOrder]);

    const finalData = isAgeing ? ageingList?.data || [] : ncrList?.data || [];

    const totalCount = isAgeing ? ageingList?.totalRecords || 0 : ncrList?.totalRecords || 0;

    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';

        // const updatedFilters = {
        //     ...filters,
        //     SortBy: property,
        //     SortOrder: isAsc ? 'desc' : 'asc'
        // };
        // if (isAgeing) {
        //     triggerAgeing({
        //         projectId,
        //         ...updatedFilters,
        //     });
        // } else {
        //     triggerNCR(updatedFilters);
        // }

        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
    };
    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        //setFilters(updatedFilters);

        if (isAgeing) {
            triggerAgeing({
                projectId,
                ...updatedFilters,
            });
        } else {
            triggerNCR(updatedFilters);
        }
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        //setFilters(updatedFilters);

        if (isAgeing) {
            triggerAgeing({
                projectId,
                ...updatedFilters,
            });
        } else {
            triggerNCR(updatedFilters);
        }
    };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    NCR Tracker - {isAgeing ? "Ageing Analysis" : "Open Vs Closed"}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        <TableComponent
                            columns={columns}
                            data={finalData}
                            createSortHandler={handleRequestSort}
                            loading={isFetching}
                            order={sortOrder}
                            orderBy={sortBy}
                        />
                    </Grid>
                    <Grid size={{ md: 12 }}>
                        <CustomPagination
                            totalCount={totalCount}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default NcrTrackerListPopUp;
